import { IsoLanguageCodes } from '../../policyholders/resilience/types';
import usePlatformRegion from './usePlatformRegion';

export function useIsoLanguageCode(): IsoLanguageCodes | null {
  const { isUS, isUK, isAU } = usePlatformRegion();

  switch (true) {
    case isUS:
      return IsoLanguageCodes.en;
    case isUK:
      return IsoLanguageCodes.eu;
    case isAU:
      return IsoLanguageCodes.au;
    default:
      return null;
  }
}
